import { Routes, Route, Link } from 'react-router-dom'

function MainEvent() {
    return(
        <>
            <div className='eventpage'> 
                <div className='event-main-character'>
                    <p>이벤트</p>
                    <img src={process.env.PUBLIC_URL + '/img/event-character.png'} />
                </div>
                <div className='event-status'>
                    <div className='event-ongoing'>
                        <div className='event-ing'>
                            <div><p>진행중</p></div>
                            <div><img src={process.env.PUBLIC_URL + '/img/.png'} /><Link to="/event/event1"></Link></div>
                            <h1>회원가입 이벤트<Link to="/event/event1"></Link> </h1>
                        </div>
                        <div className='event-ing'>
                            <div><p>진행중</p></div>
                            <div><img src={process.env.PUBLIC_URL + '/img/.png'} /><Link to="/event/event2"></Link></div>
                            <h1>펫키지 수다출첵 이벤트<Link to="/event/event2"></Link></h1>
                        </div>
                    </div>
                    <div className='event-end'>
                        <div className='event-end-post'>
                            <div><p>종료</p></div>
                            <div><img src={process.env.PUBLIC_URL + '/img/.png'} /><Link to="/event/end-event1"></Link></div>
                            <h1>수다왕 이벤트<Link to="/event/end-event1"></Link></h1>
                        </div>
                    <div className='event-end-post'>
                        <div><p>종료</p></div>
                            <div><img src={process.env.PUBLIC_URL + '/img/.png'} /><Link to="/event/end-event2"></Link></div>
                            <h1>팻 자랑 이벤트<Link to="/event/end-event2"></Link></h1>
                    </div>
                </div>
              </div>
            </div>
        </>
    )
}

export default MainEvent;